import React from 'react';
import Partner7 from 'assets/images/7.png';
import Partner71 from 'assets/images/71.png';
import Partner72 from 'assets/images/72.png';
import Partner73 from 'assets/images/73.png';
import Partner74 from 'assets/images/74.png';
import Partner75 from 'assets/images/75.png';
import Partner76 from 'assets/images/76.png';

// Array de logotipos de socios usando imágenes locales
const partners = [
    { name: 'Partner 1', logo: Partner7 },
    { name: 'Partner 2', logo: Partner71 },
    { name: 'Partner 3', logo: Partner72 },
    { name: 'Partner 4', logo: Partner73 },
    { name: 'Partner 5', logo: Partner74 },
    { name: 'Partner 6', logo: Partner75 },
    { name: 'Partner 7', logo: Partner76 },
];

// Para crear un bucle perfecto, duplicamos el array de socios.
const extendedPartners = [...partners, ...partners];

const Partners = () => {
    return (
        <>
            {/* Necesitamos una etiqueta de estilo para la animación de fotogramas clave (keyframes) */}
            <style>
                {`
                @keyframes scroll {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }
                .animate-scroll {
                    animation: scroll 20s linear infinite;
                }
                `}
            </style>
            <div className="bg-[#f4f4f4] py-4 w-full border-t border-b border-gray-200">
                <div className="container mx-auto flex items-center">
                    <div className="w-1/3 lg:w-1/6 flex-shrink-0 text-center text-sm lg:text-lg text-gray-700 border-r border-gray-300 pr-5 font-semibold">
                        Our Partners
                    </div>
                    <div className="w-2/3 lg:w-5/6 overflow-hidden relative ml-5">
                        <div className="flex items-center animate-scroll">
                            {extendedPartners.map((partner, index) => (
                                <div key={index} className="flex-shrink-0 mx-5 lg:mx-10 flex items-center justify-center h-12">
                                    <img 
                                        src={partner.logo} 
                                        alt={partner.name}
                                        className="max-h-full object-contain"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Partners;
